import './App.css';


import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";


import Home from "./Home";
import Contact from "./Contact";
import Login from "./Login";
import Navbar from "./Navbar";

import CookieConsent from "react-cookie-consent";

import EarthquakeReportPage from './EarthquakeReportPage';
import PermissionsPage from "./PermissionsPage"; 
import TimeSettingsPage from "./TimeSettingsPage";
import TermsPage from "./TermsPage";
import PrivacyPage from "./PrivacyPage";
 
import Dashboard from "./Dashboard";
import GroupPage from "./GroupPage";
import UsagePage from "./UsagePage";
import AlertPage from "./AlertPage";
import NotFound from "./NotFound";
import SettingsPage from "./SettingsPage";
import ProtectedRoute from "./ProtectedRoute";



import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';


function App() {
  return (
    <Router>
      <div className="app-container d-flex flex-column min-vh-100">
        <Navbar />

        {/* ✅ ให้ div นี้ขยายเต็มเพื่อดัน footer */}
        <div className="flex-grow-1" style={{ paddingTop: '40px' }}>
        <Routes>
          {/* 🔒 ต้องล็อกอินก่อนเข้า */}
        

         <Route path="/" element={<Home />} />
         <Route path="/contact" element={<Contact />} />
         


          {/* 🔓 เปิดให้ทุกคนเข้าได้ */}
          <Route path="/login" element={<Login />} />

          {/* 🔒 ทุกหน้า Dashboard ต้องล็อกอิน */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/dashboard/group" element={<ProtectedRoute><GroupPage /></ProtectedRoute>} />
          <Route path="/dashboard/usage" element={<ProtectedRoute><UsagePage /></ProtectedRoute>} />
          <Route path="/dashboard/alert" element={<ProtectedRoute><AlertPage /></ProtectedRoute>} />
          <Route path="/dashboard/report" element={<ProtectedRoute><EarthquakeReportPage /></ProtectedRoute>} />
         
          <Route path="/dashboard/permissions" element={<ProtectedRoute><PermissionsPage /></ProtectedRoute>} />
          <Route path="/dashboard/timesetting" element={<ProtectedRoute><TimeSettingsPage /></ProtectedRoute>} />
          <Route path="/dashboard/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />

          <Route path="/terms" element={<ProtectedRoute><TermsPage /></ProtectedRoute>} />
          <Route path="/privacy" element={<ProtectedRoute><PrivacyPage /></ProtectedRoute>} />

          <Route path="*" element={<NotFound />} />
        </Routes>

        </div>

        <footer className="bg-dark text-white text-center py-3">
          <div className="container">
            <small>
              &copy; {new Date().getFullYear()} KSN2018.com &nbsp;|&nbsp;
              <Link to="/terms" className="text-warning">ข้อกำหนดการใช้งาน</Link> &nbsp;|&nbsp;
              <Link to="/privacy" className="text-warning">นโยบายความเป็นส่วนตัว</Link>
            </small>
          </div>
        </footer>
      </div>

      {/* ✅ Cookie อยู่ภายนอก layout */}
      <CookieConsent
        location="bottom"
        buttonText="ยอมรับ"
        cookieName="thaiAlertCookieConsent"
        style={{
          background: "#2B373B",
          fontSize: "14px",
          bottom: "40px",
          zIndex: 1050
        }}
        buttonStyle={{
          color: "#fff",
          backgroundColor: "#f39c12",
          borderRadius: "4px",
          padding: "6px 16px"
        }}
        expires={150}
      >
        เว็บไซต์นี้ใช้คุกกี้เพื่อพัฒนาประสบการณ์ของคุณ หากคุณใช้งานเว็บไซต์ต่อ ถือว่าคุณยินยอมตาม{" "}
        <a href="/contact" style={{ color: "#61dafb", textDecoration: "underline" }}>
          นโยบายความเป็นส่วนตัว
        </a>
      </CookieConsent>
    </Router>
  );
}

export default App;
